module.exports = __webpack_public_path__ + "static/img/personalLittle.64632986.png";